<nz-form-item class="app-send-message">
  <nz-form-label translate>messages.newMessageThread.message</nz-form-label>
  <nz-form-control [formGroup]="form">
    <div
      contenteditable="true"
      [attr.placeholder]="'messages.threadDetails.placeholder' | translate: locale.language"
      [attr.maxLength]="messageBodyLength"
      (input)="onInput($event)"
      (paste)="onPaste($event)"
      class="app-send-message-input"
      data-cy="send-message-input"
    ></div>
    <div class="ant-form-item-explain" [ngClass]="{ 'ant-form-item-explain-error': showMaxLengthError }" data-cy="send-message-error">
      @if (showMaxLengthError) { {{ 'validation.maxlength' | translate: locale.language: { requiredLength: messageBodyLength } }} }
    </div>
  </nz-form-control>
</nz-form-item>
